import {
  getReq,
  // postReq,
  // deleteSendReq,
  // putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  costColumnSearchInfo: {
    costColName: '',
    projId: '',
    compId: '',
    status: ''
  },
  costColumnListObject: {
    costColumnList: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  },
  costColumnInfo: {
    costColId: '',
    costColName: '',
    costColDesc: '',
    projId: '',
    compId: '',
    seq: 0,
    status: '',
    crtBy: '',
    crtOn: 0,
    updBy: '',
    updOn: 0
    // ,
    //
    // extCompName: ''
  },
  costColumnDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  // async insertCostColumn({
  //   dispatch,
  //   commit,
  //   state
  // }) {
  //   // debugger
  //   const insertObj = await postReq(END_POINTS.INSERT_RSP_COST_COLUMN, {
  //     data: {
  //       costColName: state.costColumnInfo.costColName,
  //       costColDesc: state.costColumnInfo.costColDesc,
  //       projId: state.costColumnInfo.projId,
  //       compId: state.costColumnInfo.compId,
  //       status: state.costColumnInfo.status
  //     },
  //     headerMap: await getCPHeaderMap(state.costColumnInfo.compId, state.costColumnInfo.projId)
  //   })
  //   return insertObj
  // },
  // async updateCostColumn({
  //   dispatch,
  //   commit,
  //   state
  // }, {costColId, projId, compId}) {
  //   let costColumnInfo = {
  //     costColName: state.costColumnInfo.costColName,
  //     costColDesc: state.costColumnInfo.costColDesc,
  //     status: state.costColumnInfo.status,
  //     //
  //     costColId: costColId,
  //     projId: projId,
  //     compId: compId
  //   }
  //   const updateObject = await putReq(END_POINTS.UPDATE_RSP_COST_COLUMN, {
  //     data: costColumnInfo,
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   return updateObject
  // },
  // async removeCostColumn({
  //   commit,
  //   state
  // }, {costColId, projId, compId}) {
  //   const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_COST_COLUMN + `?costColId=${costColId}&projId=${projId}&compId=${compId}`, {
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   return deleteObject
  // },
  // async findCostColumn({
  //   commit
  // }, {costColId, projId, compId}) {
  //   const responseData = await getReq(END_POINTS.FIND_RSP_COST_COLUMN + `?costColId=${costColId}&projId=${projId}&compId=${compId}`, {
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   if (responseData.success) {
  //     commit('updateCostColumnInfo', responseData.data)
  //   } else {
  //     commit('updateCostColumnInfo', {})
  //   }
  // },
  // async findCostColumnCondition({
  //   commit,
  //   state,
  //   rootState
  // }, { currentPage, pageSize }) {
  //   let stateCurrentPage = currentPage
  //   if (pageSize) {
  //     state.costColumnListObject.pageSize = pageSize
  //     stateCurrentPage = 1
  //   }
  //   const costColumnListObject = await postReq(END_POINTS.FIND_RSP_COST_COLUMN_CONDITION, {
  //     data: {
  //       currentPage: stateCurrentPage,
  //       orderBy: '',
  //       pageSize: state.costColumnListObject.pageSize,
  //       queryVO: {
  //         costColName: state.costColumnSearchInfo.costColName,
  //         projId: state.costColumnSearchInfo.projId,
  //         compId: state.costColumnSearchInfo.compId,
  //         status: state.costColumnSearchInfo.status
  //       },
  //       refreshTotalRecord: true
  //     },
  //     headerMap: await getCPHeaderMap(state.costColumnSearchInfo.compId, state.costColumnSearchInfo.projId)
  //   })
  //   commit('updateCostColumnListObject', costColumnListObject)
  // },
  async findRspCostColumnDDList({
    commit,
    state
  }, { projId, compId, codeParam }) {
    // debugger
    const responseData = await getReq(END_POINTS.FIND_RSP_COST_COLUMN_DD_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateCostColumnDDList', responseData.data)
    } else {
      commit('updateCostColumnDDList', [])
    }
  },
  END_ACTIONS() {}
}

const mutations = {
  updateSearchCostColName(state, value) {
    state.costColumnSearchInfo.costColName = value
  },
  updateSearchProjId(state, value) {
    state.costColumnSearchInfo.projId = value
  },
  updateSearchCompId(state, value) {
    state.costColumnSearchInfo.compId = value
  },
  updateSearchStatus(state, value) {
    state.costColumnSearchInfo.status = value
  },
  //
  updateCostColName(state, value) {
    state.costColumnInfo.costColName = value
  },
  updateCostColDesc(state, value) {
    state.costColumnInfo.costColDesc = value
  },
  updateProjId(state, value) {
    state.costColumnInfo.projId = value
  },
  updateCompId(state, value) {
    state.costColumnInfo.compId = value
  },
  updateStatus(state, value) {
    state.costColumnInfo.status = value
  },
  //
  updateCostColumnListObject(state, costColumnListObject) {
    if (costColumnListObject.code === 2001) {
      state.costColumnListObject.costColumnList = costColumnListObject.data.map(value => {
        return {
          costColId: value.costColId,
          costColName: value.costColName,
          costColDesc: value.costColDesc,
          projId: value.projId,
          compId: value.compId,
          status: value.status,
          crtBy: value.crtBy,
          crtOn: value.crtOn,
          updBy: value.updBy,
          updOn: value.updOn
          // ,
          //
          // extCompName: value.extCompName
        }
      })
      state.costColumnListObject.currentPage = costColumnListObject.currentPage
      state.costColumnListObject.pageSize = costColumnListObject.pageSize
      state.costColumnListObject.total = costColumnListObject.total
      state.costColumnListObject.totalPage = costColumnListObject.totalPage
    } else {
      state.costColumnListObject.costColumnList = []
      state.costColumnListObject.total = 0
    }
  },
  updateCostColumnEmpty(state) {
    state.costColumnInfo.costColId = ''
    state.costColumnInfo.costColName = ''
    state.costColumnInfo.costColDesc = ''
    state.costColumnInfo.projId = ''
    state.costColumnInfo.compId = ''
    state.costColumnInfo.status = ''
    state.costColumnInfo.crtBy = ''
    state.costColumnInfo.crtOn = 0
    state.costColumnInfo.updBy = ''
    state.costColumnInfo.updOn = 0
    //
    // state.costColumnInfo.extCompName = ''
  },
  updateCostColumnInfo(state, costColumnInfo) {
    // debugger
    // state.costColumnInfo.costColId = costColumnInfo.costColId
    state.costColumnInfo.costColName = costColumnInfo.costColName
    state.costColumnInfo.costColDesc = costColumnInfo.costColDesc
    state.costColumnInfo.projId = costColumnInfo.projId
    state.costColumnInfo.compId = costColumnInfo.compId
    state.costColumnInfo.status = costColumnInfo.status
    state.costColumnInfo.crtBy = costColumnInfo.crtBy
    state.costColumnInfo.crtOn = costColumnInfo.crtOn
    state.costColumnInfo.updBy = costColumnInfo.updBy
    state.costColumnInfo.updOn = costColumnInfo.updOn
    //
    // state.costColumnInfo.extCompName = costColumnInfo.extCompName
  },
  updateCostColumnDDList(state, list) {
    // state.costColumnDDList = value
    state.costColumnDDList = Utils.toListWapper(list, {valueField: 'costColId', descrField: 'costColName'})
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/conf/rspCostColumnManage.js